import React, { Component } from 'react';

export default class Footer extends Component {

	render() {
    console.log('Footer');
    return (
      <div id="footer">2018 atRound LLC. <a href="/terms">Terms and conditions</a></div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer.jsx